import { Component, OnInit, Input, EventEmitter, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { serviceConstants, departmentsOptionsConstant, documentOptionsConstant } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { EditAndDeleteOperationsRenderer } from 'src/app/common/client-grid/edit-and-delete-operations.component';
import { GridApi } from 'ag-grid-community';
import { DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { AttachmentClassificationComponent } from 'src/app/common/attachment-classification/attachment-classification.component';
import { IstDataShareService } from '../../../../services/ist/ist-datashare.service';
import { MessageBoxComponent } from '../../../../common/message-box/message-box.component';
import { UserService } from '../../../../services/user.service';
import { DatePipe } from '@angular/common';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { CommonService } from 'src/app/services/common.service';
import * as $ from 'jquery';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { EditOthersRenderer } from 'src/app/common/client-grid/edit-others-operations.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateObject } from 'src/app/models/common';
import { MileStone, Organization } from 'src/app/models/um/organization';

@Component({
  selector: 'app-ist-milestones-view-modal',
  templateUrl: './ist-milestones-view-modal.component.html',
  styleUrls: ['./ist-milestones-view-modal.component.scss']
})
export class IstMilestonesViewModalComponent implements OnInit {

  @Input() public Content: any;
  departments = departmentsOptionsConstant;
  selectedProduct: any;
  milestoneForm: UntypedFormGroup;
  content: any;
  heading: string;
  ist_milestone : MileStone;
  action: Subject<any> = new Subject();
  formData: FormData;
  documentOptions = documentOptionsConstant;
  columnDefs;
  context;
  frameworkComponents;
  ApplicationID: any;
  userType: string = "";
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  myDate = new Date();
  year = this.myDate.getFullYear();
  moth = this.myDate.getMonth() + 1;
  Day = this.myDate.getDate();
  gridApi: GridApi;
  operations: any[] = [];
  Attachments: any[] = [];
  RequiredSettings: boolean = true;
  rowData;
  selectedRow: any;
  loadGrid = false;
  gridOptions;
  AppStatus: any
  StartDate: Date
  EndDate: Date
  STUDY_START_DATEO: DateObject
  STUDY_END_DATEO: DateObject

  TempOperations: { name: string; id: string; }[];
  staticformFields: any;

  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    private userService: UserService,
    private commonService: CommonService,
    public datepipe: DatePipe

  ) {
    this.context = { componentParent: this };
    this.frameworkComponents = {
      deleteRenderer: EditAndDeleteOperationsRenderer
    };
  }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
      });
  }

  ngOnInit() {
    this.getStaticFiledsData('SCR-008');
    this.AppStatus = this.commonService.getIstStatus();
    this.rowData = [];
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    this.userType = this.userService.getUserType();
    this.milestoneForm = new UntypedFormGroup({
      ID: new UntypedFormControl(""),
      APPLICATION_ID: new UntypedFormControl(""),
      MILESTONE_NO: new UntypedFormControl(""),
      STUDY_START_DATE: new UntypedFormControl(null),
      STUDY_END_DATE: new UntypedFormControl(null),
      TITLE: new UntypedFormControl(""),
      NOTES: new UntypedFormControl(""),
      STATUS: new UntypedFormControl(0),
      STUDY_START_DATEO: new UntypedFormControl(null),
      STUDY_END_DATEO: new UntypedFormControl(null)
    });

    if (this.Content.heading === 'Edit') { // Edit mode
      this.getRecordFprEdit();
      this.ist_milestone = new MileStone();

    }
    else if (this.Content.heading === 'View') { //View mode
      this.getRecordFprEdit();
      this.milestoneForm.disable();
    }
    else if (this.Content.heading === 'Add') { //Add mode
      this.Content.content.id = this.commonService.getUniqueId();
    }
    this.StartDate = new Date();
    this.EndDate = new Date();
    this.TempOperations = [];

    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,
      IsScreenGrid: true,
      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,
      }
    }

    this.columnDefs = [
      {
        "headerName": "Attachment Classification",
        "field": "AttachmentClassification"
      },
      {
        "headerName": "File Name",
        "field": "FileName"
      },
      {
        "headerName": "Date",
        "field": "Date"
      },
      {
        headerName: "",
        field: "value",
        cellRenderer: "editOthersRenderer",
        colId: "params",
        width: 50,
        sortable: false,
        cellStyle: { "overflow": 'visible' }
      }
    ];

    this.context = { componentParent: this };
    this.frameworkComponents = {
      editOthersRenderer: EditOthersRenderer
    };

    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,

      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,
      }
    }
  }

  deleteRow() { }

  getRecordFprEdit() {
    this.summaryService.getScreenDataForEdit("api/ISTMilestones/Edit?RecordID=" + this.Content.content.id).subscribe(result => {
      this.milestoneForm.patchValue({
        ID: result["ID"],
        APPLICATION_ID: result["APPLICATION_ID"],
        MILESTONE_NO: result["MILESTONE_NO"],
        STUDY_START_DATE: result["STUDY_START_DATE"],
        STUDY_END_DATE: result["STUDY_END_DATE"],
        TITLE: result["TITLE"],
        NOTES: result["NOTES"],
        STATUS: result["STATUS"],
      });

      if (result["STUDY_START_DATE"] != null && result["STUDY_START_DATE"] != "") {
        
        this.StartDate = this.commonService.getdisplayedDate(this.milestoneForm.controls["STUDY_START_DATE"].value);
        this.milestoneForm.controls["STUDY_START_DATE"].setValue(this.StartDate);
      
      }
      if (result["STUDY_END_DATE"] != null && result["STUDY_END_DATE"] != "") {
        
        this.EndDate = this.commonService.getdisplayedDate(this.milestoneForm.controls["STUDY_END_DATE"].value);
         this.milestoneForm.controls["STUDY_END_DATE"].setValue(this.EndDate);
      }
      if (this.milestoneForm.controls["STATUS"].value == '2') { // Edit mode
        this.milestoneForm.disable();
        this.Content.heading = "View";
      }

      this.rowData = result["Attachments"];
      this.setOperations(this.rowData);
      setTimeout(() => {
        this.loadGrid = true;
        document.body.click();
      }, 300);

      this.extendedForm.rowid = result["ID"];
      this.extendedForm.getResponse();
    });
  }
  editRow() {
  }
  CompareDates(olddate: any, newDate: any): boolean {
    if (olddate != '' && olddate != undefined && olddate != null) {

      let oDt = olddate.getDate().toString() + olddate.getMonth().toString() + olddate.getFullYear().toString();
      let nDt = newDate.getDate().toString() + newDate.getMonth().toString() + newDate.getFullYear().toString();
      if (oDt == nDt) { return true }
      else { return false }
    }
    else
      return false
  }

  isStartDateModified: boolean = false;
  isEndDateModified: boolean = false;
  Full_Start_Date: DateObject;
  Full_End_Date: DateObject;

  startDateSelect(event) {
    debugger
    this.isStartDateModified = true
    this.Full_Start_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isStartDateModified
    }
  }

  endDateSelect(event) {
    this.isEndDateModified = true;
    this.Full_End_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: true,
      HasValue: true,
      IsDateModified: this.isEndDateModified
    }
  }

  GetStartDate(): DateObject {
    //let lDate = this.milestoneForm.controls['STUDY_START_DATE'].value;
    var formModel = this.milestoneForm.getRawValue();
    const lDate = new Date(formModel.STUDY_START_DATE);
    //let lDate = new Date(this.milestoneForm['STUDY_START_DATE'])
    if (((this.CompareDates(this.StartDate, lDate) || this.Full_Start_Date == null || this.Full_Start_Date == undefined) 
    && formModel.STUDY_START_DATE != null)) {
      this.Full_Start_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 0,
        Minutes: 0,
        Seconds: 0,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false
      }
    }
    else{
      this.Full_Start_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 0,
        Minutes: 0,
        Seconds: 0,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: true
      }
    }
    return this.Full_Start_Date
  }

  GetEndDate(): DateObject {
    const formModel = this.milestoneForm.getRawValue();
    const lDate = new Date(formModel.STUDY_END_DATE);
    if ((this.CompareDates(this.EndDate, lDate) || this.Full_End_Date == null || this.Full_End_Date == undefined) && formModel.STUDY_END_DATE!=null)
      this.Full_End_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: true,
        HasValue: true,
        IsDateModified: false
      }
      else{
        this.Full_End_Date = {
          Day: lDate.getDate(),
          Month: lDate.getMonth() + 1,
          Year: lDate.getFullYear(),
          Hours: 23,
          Minutes: 59,
          Seconds: 59,
          IsEndDate: true,
          HasValue: true,
          IsDateModified: true
        }
      }
    return this.Full_End_Date;
  }


  private getForm(): MileStone {
    const formModel = this.milestoneForm.getRawValue();
    let obj = new MileStone();
    obj = {
      ID: formModel.ID,
      APPLICATION_ID: formModel.APPLICATION_ID || '',
      MILESTONE_NO: formModel.MILESTONE_NO || '',
      STUDY_START_DATE: formModel.STUDY_START_DATE || null,
      STUDY_END_DATE: formModel.STUDY_END_DATE || null,
      STUDY_START_DATEO : formModel.STUDY_START_DATEO || null,
      STUDY_END_DATEO : formModel.STUDY_END_DATEO || null,
      TITLE: formModel.TITLE || "",
      NOTES: formModel.NOTES || "",
      STATUS: formModel.STATUS || 0,
    };

    if (this.Content.heading !== 'Add') {
        this.ist_milestone.ID = obj.ID;
        this.ist_milestone.APPLICATION_ID = obj.APPLICATION_ID;
        this.ist_milestone.MILESTONE_NO = obj.MILESTONE_NO;
        this.ist_milestone.NOTES = obj.NOTES;
        this.ist_milestone.TITLE = obj.TITLE;
        this.ist_milestone.STUDY_START_DATE = obj.STUDY_START_DATE;
        const sdate = this.GetStartDate();
        this.ist_milestone.STUDY_START_DATEO=sdate;
        this.ist_milestone.STUDY_END_DATE=obj.STUDY_END_DATE;
        const edate = this.GetEndDate();
        this.ist_milestone.STUDY_END_DATEO=edate;
        return this.ist_milestone;
    }
    else {
      const sdate = this.GetStartDate();
      const edate = this.GetEndDate();
      obj.STUDY_START_DATEO = sdate;
      obj.STUDY_END_DATEO = edate;
    }
    return obj;
  }


  

  SaveMileStonesData() {
    if (this.validateControls()) {
      let mileStone = this.milestoneForm.controls["TITLE"].value;
   //   var formData = this.milestoneForm.value;
         var formData = this.getForm();
     


      if (formData["STUDY_START_DATE"] != null) {
        const ldate = new Date(formData["STUDY_START_DATE"]);
        formData["STR_STUDY_START_DATE"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();
         formData["STUDY_START_DATE"] = new Date(formData["STUDY_START_DATE"]);
      }
      if (formData["STUDY_END_DATE"] != null) {
        const ldate = new Date(formData["STUDY_END_DATE"]);
        formData["STR_STUDY_END_DATE"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();
        formData["STUDY_END_DATE"] = new Date(formData["STUDY_END_DATE"]);
      }
      formData["APPLICATION_ID"] = this.ApplicationID;
      formData["STATUS"] = 1;
      this.rowData.forEach(element => {
        element["Operations"] = [];
      });
      formData["Attachments"] = this.rowData;

      if (this.Content.heading == "Add") {
        formData["ID"] = this.Content.content.id;
        this.summaryService.Insert("api/ISTMilestones/Insert", formData).subscribe(result => {
          if (result.Status === 0) {
            this.milestoneForm.controls["ID"].setValue(result.TransactionID);
            this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              if (result1.Status === 0) {
                this.commonService.SuccessBanner('Milestone ' + mileStone + ' Added/Submitted successfully');
                this.modalRef.close();
              }
              else {
                this.commonService.ValidationBanner('Milestone ' + mileStone + ' Failed to Added/Submitted');
              }
            });
          }
          else{
            this.commonService.ValidationBanner(result.Message);
          }
        });
      }
      else {
        this.summaryService.Insert("api/ISTMilestones/Update", formData).subscribe(result => {
          if (result.Status === 0 || result.ErrorCode == "NOCHANGES") {
            this.milestoneForm.controls["ID"].setValue(result.TransactionID);
            this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              if (result1.ErrorCode == "NOCONTROLS") {
                if (result.Status === 0) {
                  this.commonService.SuccessBanner('Milestone ' + mileStone + ' details updated successfully');
                  this.modalRef.close(formData);
                }
                else {
                  this.commonService.ValidationBanner(result.Message);
                }
              }
              else
              {
                if (result.ErrorCode === "NOCHANGES" && result1.ErrorCode === "NOCHANGES") {
                  this.commonService.ValidationBanner(result.Message);
                }
                else
                {
                  this.commonService.SuccessBanner('Milestone ' + mileStone + ' details updated successfully');
                  this.modalRef.close(formData);
                }
              }
            });
          } else {

            this.commonService.ValidationBanner(result.Message);
            // this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
            //   if (result1.ErrorCode == "NOCONTROLS" && result.ErrorCode == "NOCHANGES") {
            //     this.commonService.ValidationBanner(result.Message);
            //   }
            //   else {
            //     if (result1.ErrorCode == "NOCHANGES" && result.ErrorCode == "NOCHANGES") {
            //       this.commonService.ValidationBanner(result.Message);
            //     }
            //     else {
            //       this.commonService.SuccessBanner('Milestone ' + mileStone + ' details updated successfully');
            //       // this.action.next(formData);
            //       this.modalRef.close(formData);
            //     }
            //   }
            // });
          }
        });
      }
    }
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.milestoneForm.value;

    if (this.staticformFields?.MILESTONE_NO.IS_Display && this.staticformFields?.MILESTONE_NO.IS_MANDATORY) {
      if (formData.MILESTONE_NO === null || formData.MILESTONE_NO === "") {
        $("#MILESTONE_NO").addClass("ng-touched ng-invalid validate-error");
        $("#MILESTONE_NO").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.MILESTONE_NO.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#MILESTONE_NO").addClass("ng-untouched ng-valid");
        $("#MILESTONE_NO").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    var StartDate = formData.STUDY_START_DATE;
    var EndDate = formData.STUDY_END_DATE;
    var eDate = new Date(EndDate);
    var sDate = new Date(StartDate);

    if (this.staticformFields?.STUDY_START_DATE.IS_Display && this.staticformFields?.STUDY_START_DATE.IS_MANDATORY) {
      if (StartDate === null && StartDate === undefined || StartDate === '') {
        $("#STUDY_START_DATE").addClass("ng-touched ng-invalid validate-error");
        $("#STUDY_START_DATE").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.STUDY_START_DATE.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#STUDY_START_DATE").addClass("ng-untouched ng-valid");
        $("#STUDY_START_DATE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.STUDY_END_DATE.IS_Display && this.staticformFields?.STUDY_END_DATE.IS_MANDATORY) {
      if (EndDate === null && EndDate === undefined || EndDate === '') {
        $("#STUDY_END_DATE").addClass("ng-touched ng-invalid validate-error");
        $("#STUDY_END_DATE").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.STUDY_END_DATE.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#STUDY_END_DATE").addClass("ng-untouched ng-valid");
        $("#STUDY_END_DATE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.TITLE.IS_Display && this.staticformFields?.TITLE.IS_MANDATORY) {
      if (formData.TITLE === null || formData.TITLE === "") {
        $("#TITLE").addClass("ng-touched ng-invalid validate-error");
        $("#TITLE").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.TITLE.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#TITLE").addClass("ng-untouched ng-valid");
        $("#TITLE").removeClass("ng-touched ng-invalid validate-error");
      }
    }
    if (this.staticformFields?.NOTES.IS_Display && this.staticformFields?.NOTES.IS_MANDATORY) {
      if (formData.NOTES === null || formData.NOTES === "") {
        $("#NOTES").addClass("ng-touched ng-invalid validate-error");
        $("#NOTES").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.NOTES.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#NOTES").addClass("ng-untouched ng-valid");
        $("#NOTES").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.STUDY_START_DATE.IS_Display && this.staticformFields?.STUDY_START_DATE.IS_MANDATORY
      && this.staticformFields?.STUDY_END_DATE.IS_Display && this.staticformFields?.STUDY_END_DATE.IS_MANDATORY) {
      if (StartDate != '' && StartDate != null && StartDate != undefined && EndDate != null && EndDate != '' && EndDate != undefined && sDate > eDate) {
        message = message + `${this.staticformFields?.STUDY_START_DATE.LABEL_NAME} should not greater than the ${this.staticformFields?.STUDY_END_DATE.LABEL_NAME}</br>`;
        isValid = false;
      }
    }

    let ExtenMsgs = this.extendedForm.validateControlsMsgs();
    if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
      message = message + ExtenMsgs; //this.extendedForm.validateControlsMsgs();
      isValid = false;
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);

    return isValid;
  }
  
  ClosePopUp() {
    this.modalRef.dismiss()
  }

  dataChanged(newValue) {
    this.selectedProduct = newValue
  }

  SubmitRecord() {
    if (this.validateControls()) {
      //var formData = this.milestoneForm.value;
      var formData = this.getForm();
      let mileStone = this.milestoneForm.controls["TITLE"].value;

      if (formData["STUDY_START_DATE"] != null ) {
        const ldate = new Date(formData["STUDY_START_DATE"]);
        formData["STR_STUDY_START_DATE"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();
        formData["STUDY_START_DATE"] = new Date(formData["STUDY_START_DATE"]);
      }
      if (formData["STUDY_END_DATE"] != null) {
        const ldate = new Date(formData["STUDY_END_DATE"]);
        formData["STR_STUDY_END_DATE"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();
      formData["STUDY_END_DATE"] = new Date(formData["STUDY_END_DATE"]);
      }
      formData["STATUS"] = 2;
      formData["APPLICATION_ID"] = this.ApplicationID;
      this.rowData.forEach(element => {
        element["Operations"] = [];
      });
      formData["Attachments"] = this.rowData;

      if (this.Content.heading == "Add") {
        formData["ID"] = this.Content.content.id;
        this.summaryService.Insert("api/ISTMilestones/Insert", formData).subscribe(result => {
          if (result.Status === 0) {
            this.milestoneForm.controls["ID"].setValue(result.TransactionID);
            this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              if (result1.Status === 0) {
                this.commonService.SuccessBanner('Milestone ' + mileStone + ' Added/Submitted successfully');
              this.modalRef.close();
              }
              else{
                this.commonService.ValidationBanner(result1.Message);
              }
            });
          }
          else{
            this.commonService.ValidationBanner(result.Message);
          }
        });
      }
      else {
        this.summaryService.Insert("api/ISTMilestones/Update", formData).subscribe(result => {
          if (result.Status === 0 || result.ErrorCode=="NOCHANGES") {
            this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              if(result1.ErrorCode === "NOCONTROLS")
              {
                if (result.Status === 0) {
                  this.commonService.SuccessBanner('Milestone ' + mileStone + ' submitted successfully');
                  this.modalRef.close();
                }
                else {
                  this.commonService.ValidationBanner(result.Message);
                }
              }
              else{
                if (result.ErrorCode === "NOCHANGES" && result1.ErrorCode === "NOCHANGES") {
                  this.commonService.ValidationBanner(result.Message);
                }
                else{
                  this.commonService.SuccessBanner('Milestone ' + mileStone + ' submitted successfully');
                  this.modalRef.close(formData);
                }
              }
            });

          }
          else{
            this.commonService.ValidationBanner(result.Message);
          }

          // if (result.Status === 0) {
          //   this.milestoneForm.controls["ID"].setValue(result.TransactionID);
          //   this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
          //     this.commonService.SuccessBanner('Milestone ' + mileStone + ' submitted successfully');

          //     this.modalRef.close();
          //   });
          // } else {
          //   this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
          //     if (result1.ErrorCode == "NOCHANGES" && result.ErrorCode == "NOCHANGES") {
          //       this.commonService.ValidationBanner(result.Message);
          //     }
          //     else {
          //       this.commonService.SuccessBanner('Milestone ' + mileStone + ' submitted successfully');
          //       // this.action.next(formData);
          //       this.modalRef.close(formData);
          //     }
          //   });
          // }

        });
      }
    }
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  getAttachmentsData() {
    this.summaryService.getSummaryData("api/ISTFileAttachments/getScreenAttachments?TransactionID=" + 1).subscribe((result) => {
      this.rowData = result;
      setTimeout(() => {
        this.loadGrid = true;
        document.body.click();
      }, 350);
    });
  }

  addNewAttachment() {
    let modalRef = this.modalService.open(AttachmentClassificationComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Add',
      screencode:"SCR-008",
      is_ac_display:this.staticformFields.Milestone_AC.IS_Display,
      is_ac_mand:this.staticformFields.Milestone_AC.IS_MANDATORY,
      ac_label:this.staticformFields.Milestone_AC.LABEL_NAME,
      is_file_display:this.staticformFields.Milestone_CF.IS_Display,
      is_file_mand:this.staticformFields.Milestone_CF.IS_MANDATORY,
      file_lable:this.staticformFields.Milestone_CF.LABEL_NAME,
      file_subLabel:this.staticformFields.Milestone_CF.SUB_LABEL,
      is_multiple_files:this.staticformFields.Milestone_CF.IS_MULTISELECT,
      content: { id: "", ModuleName: "IST", ScreenName: 'Milestones', filesList: this.rowData }
    }
    modalRef.result.then(result => {
      this.loadGrid = false;
      result.forEach((item: any) => {
        this.rowData.push(item);
      });
      this.setOperations(this.rowData);
      setTimeout(() => {
        this.loadGrid = true;
        document.body.click();
      }, 300);
    })
  }

  setOperations(RawData: any): any {
    let tempOperations;
    if (this.Content.heading == 'Edit') {
      tempOperations = [
        {
          "name": "Delete",
          "id": "Delete"
        },
        {
          "name": "Download",
          "id": "Download"
        },
        {
          "name": "Preview",
          "id": "ViewFile"
        }
      ];
    }

    if (this.Content.heading == 'View') {
      tempOperations = [
        {
          "name": "Download",
          "id": "Download"
        },
        {
          "name": "Preview",
          "id": "ViewFile"
        }
      ];
    }
    if (this.Content.heading == "Add") {

      tempOperations = [
        {
          "name": "Delete",
          "id": "Delete"
        }
      ];
    }

    this.setDef(tempOperations);

    RawData.forEach(element => {
      if (element.Status == "Add" && this.Content.heading == 'Edit') {
        this.TempOperations = [];
        this.TempOperations.push(
          {
            "name": "Delete",
            "id": "Delete"
          }
        );
        element["Operations"] = this.setDef(this.TempOperations);
      } else {
        element["Operations"] = this.setDef(tempOperations);
      }
    });
    return RawData;
  }

  setDef(parmoperations: any): any {

    this.operations = parmoperations.map(operation => {
      return operation &&
        (operation.id === "add" || operation.id === "view_modal")
        ? {
          name: operation.name,
          callback: this[operation.id],
          self: this,
          disabled: "false"
        }
        : { name: operation.name, callback: this[operation.id], self: this };
    });
    return this.operations;
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onOperationClick(opr) {
    opr.callback();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    setTimeout(() => {
      this.gridApi.sizeColumnsToFit();
      this.gridApi.startEditingCell(params);
    }, 500);
  }

  Download() {
    var fileID = this['self'].selectedRow['FileID'];
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }

  ViewFile() {
    var fileID = this['self'].selectedRow['FileID'];
    var fileName = this['self'].selectedRow['FileName'];
    this['self'].commonService.previewFile(fileID, fileName, "med");
  }

  Delete() {
    var fileID = this['self'].selectedRow['FileID'];
    var fileName = this['self'].selectedRow['FileName'];
    let modalRef = this["self"].modalService.open(DeleteBoxComponent, {backdrop: false});
    modalRef.componentInstance.Content = { heading: '', custommessage: 'Are you sure you want to delete the ' + fileName + '?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel" };
    modalRef.result.then(result => {
      if (result == 'okclick') {
        let index = this['self'].rowData.findIndex(x => x.FileID == fileID);
        if (index != null) {
          this['self'].rowData.splice(index, 1);
          this['self'].loadGrid = false;
          setTimeout(() => {
            this['self'].loadGrid = true;
            document.body.click();
          }, 300);
        }
      }
    });
  }
}

